import { Navigate, useLocation } from "react-router-dom";
import { unknownRouteNavigateState } from "@/utils/accessDenied";

/** Catch-all: send them home and let the shell explain why. */
export default function UnknownRouteRedirect({ to }: { to: string }) {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate to={to} replace state={unknownRouteNavigateState(`${pathname}${search}${hash}`)} />
  );
}
